var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{ 'narrowed': _vm.searchFormNarrowed },attrs:{"role":"search"}},[_c('form',{attrs:{"id":"search-form"}},[_c('search-box',{on:{"search-by-fields":function($event){return _vm.$emit('search-by-fields')}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }